
import iconInstagram from "../../assets/images/icons/icon-instagram.svg";
import iconFB from "../../assets/images/icons/icon-fb.svg";
import iconTwitter from "../../assets/images/icons/icon-twitter.svg";
import iconLinkedin from "../../assets/images/icons/icon-linkedin.svg";

export const socialLink = [
  {
    link: "https://www.facebook.com/value360communications",
    icon: iconFB,
    altTag: "icon-fb"
  },
  {
    link: "https://twitter.com/value_360",
    icon: iconTwitter,
    altTag: "icon-twitter"
  },
  {
    link: "https://www.instagram.com/value360communications/",
    icon: iconInstagram,
    altTag: "icon-insta"
  },
  {
    link: "https://www.linkedin.com/company/value360communications/mycompany/",
    icon: iconLinkedin,
    altTag: "icon-linkedin"
  }
]